import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FREE_SUBSCRIPTION_PLAN_ID } from "../../constants/constants";
import { analyticsLog } from "../../lib/analytics";
import { fetchMembershipData } from "../../redux-stores/slices/membershipSlice";
import { AppDispatch, RootState } from "../../redux-stores/store";
import MembershipSkeleton from "../../skeletons/MembershipSkeleton";
import { SubscriptionFeature } from "../../types/membership/membershipTypes";
import { toValidNumber } from "../../utils/helpers";
import { setHeader, setShowFooterNav } from "../../redux-stores/slices/layoutSlice";
import { defaultAppHeaderProps } from "../../types/layout/layoutTypes";
import "./style.scss";
const Membership: React.FC = () => {

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, active_plan: activePlan, subscription_features: subscriptionFeatures } = useSelector((state: RootState) => state.membership);

    const fetchData = useCallback(async (force = false) => {
        dispatch(fetchMembershipData(force))
    }, [dispatch])

    useEffect(() => {
        if (activePlan) {
            analyticsLog('subscription_view', {
                plan: activePlan.plan?.name
            })
        }
    }, [activePlan])

    useEffect(() => {
        fetchData();
    }, [fetchData])

    useEffect(() => {
        dispatch(setHeader({
            generic: false,
            page: {
                title: 'Manage Subscription',
                onBackClick: () => {
                    navigate(-1);
                },
            }
        }))
        return () => {
            dispatch(setHeader(defaultAppHeaderProps))
        }
    }, [dispatch, navigate])

    useEffect(() => {
        dispatch(setShowFooterNav(false));
        return () => {
            dispatch(setShowFooterNav(true));
        }
    }, [dispatch])

    const applicationsFeature = subscriptionFeatures?.applications;

    if (loading) return <div className="app-page p-0"><MembershipSkeleton /></div>

    return (
        <div className="app-page p-0 bg-white membership-page">
            <div className="p-3 membership-content">
                <div
                    className="mb-3 membership-card"
                >
                    <div className="d-flex align-items-start justify-content-between gap-2">
                        <div className="d-flex flex-column">
                            <div className="membership-section-title">
                                Curent Plan Details
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 d-flex flex-column gap-2 membership-rows">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="membership-row-label">Subscription Type</div>
                            <div className="membership-row-value">
                                {activePlan?.plan?.name}
                            </div>
                        </div>

                        {activePlan?.platform && (
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="membership-row-label">Payment Amount</div>
                                <div className="membership-row-value">
                                    ₹{toValidNumber(activePlan?.billing_amount)}
                                </div>
                            </div>
                        )}

                        {activePlan?.platform && (
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="membership-row-label">Next Payment Due</div>
                                <div className="membership-row-value text-end">
                                    {activePlan.next_due_date}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className={`app-card-wrapper pro`}>
                    <div
                        className="app-card box-shadow-none"
                    >
                        <div className="membership-section-title">
                            Curent Plan Perks
                        </div>

                        <div className="mt-3 d-flex flex-column gap-2">
                            {subscriptionFeatures && Object.values(subscriptionFeatures).map((sf: SubscriptionFeature, i: number) => {
                                if (!sf.is_visible || sf.slug === 'applications') return null;

                                const isConsumable = sf.type === 'consumable';
                                const enabled = !!sf.applicable_limit;
                                const iconClass = isConsumable ? "fa fa-check-circle color-green-dark" : (enabled ? "fa fa-check-circle color-green-dark" : "fa fa-times-circle color-red-dark");

                                return (
                                    <div key={i} className="d-flex align-items-start justify-content-between gap-2 membership-perk-item">
                                        <div className="d-flex align-items-start gap-2">
                                            <i className={`${iconClass} membership-perk-icon`}></i>
                                            <div className="membership-perk-name">{sf.name}</div>
                                        </div>
                                        {isConsumable && (
                                            <div className="text-end membership-perk-usage">
                                                {sf.consumed_limit}/{sf.applicable_limit}
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="additional-info membership-consumption-info pro">
                        <div className="d-flex align-items-center gap-1">
                            <div className="membership-perk-usage">
                                {applicationsFeature?.consumed_limit}/{applicationsFeature?.applicable_limit}
                            </div>
                            <div className="membership-perk-name">
                                Campaigns applied
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div className="sticky-footer w-d-100 box-shadow-none">
                <button onClick={() => navigate('/subscription-plans')} className='btn btn-primary w-100'>UPGRADE</button>
            </div>
        </div>
    )
}

export default Membership